export const CURRENT_PAGE_CLASS_NAME =
  'sd-progress-buttons__list-element--current';
